const ItemType = require('@/lib/Items/ItemType');

/**
 * This class represents one page on ProPoint.
 */
class AppPage {
    /**
     * @param {string} top
     * @param {string|null} [secondary]
     */
    constructor(top, secondary = null) {
        this.top = top;
        this.setSecondary(secondary);
    }

    setSecondary(secondary) {
        if (secondary) {
            this.secondary = secondary;
            this.secondaryItemType = AppPage.landingPagePartToItemType(secondary);
        } else {
            this.secondary = null;
            this.secondaryItemType = null;
        }
    }

    /**
     * @param {string} key
     *
     * @return {AppPage|null}
     */
    static fromKey(key) {
        const parts = key.split('.');
        if (parts.length < 1) {
            return null;
        }

        if (parts.length === 2) {
            return new AppPage(parts[0], parts[1]);
        }

        return new AppPage(parts[0]);
    }

    /**
     * Convert LandingPage key to ItemType.
     *
     * @param {string} key
     *
     * @return {string|null}
     */
    static landingPagePartToItemType(key) {
        switch (key) {
            case 'tickets':
                return ItemType.TICKET;
            case 'products':
                return ItemType.PRODUCT;
            case 'foodAndDrink':
                return ItemType.PRODUCT_FOOD;
            case 'membershipPlans':
                return ItemType.MEMBERSHIP_PLAN;
        }

        return null;
    }
}

module.exports = AppPage;
